import parse from 'date-fns/parse';
import isValid from 'date-fns/is_valid';
import format from 'date-fns/format';
import { maxLength, required } from '../../utils/validation';

export const WorkflowValidations = {
  name: [
    required('models.workflow.name'),
    maxLength(24, 'models.workflow.name')
  ]
};

class Serializer {
  normalize = data => {
    let updatedAtValid = isValid(
      parse(data.assetInfo.metadata.props.updatedAt || '')
    );
    let createdAtValid = isValid(
      parse(data.assetInfo.metadata.props.createdAt || '')
    );
    return {
      id: data.id,
      name: data.value,
      site: {
        id: data.assetInfo.metadata.props.siteId
      },
      isActive: true,
      active: +(data.assetInfo.metadata.props.activeTags || 0),
      total: +(data.assetInfo.metadata.props.totalTags || 0),
      lastUpdated: updatedAtValid
        ? format(data.assetInfo.metadata.props.updatedAt, 'MMM D, YYYY HH:mm')
        : '',
      lastUpdatedBy: data.assetInfo.metadata.props.updatedBy,
      created: createdAtValid
        ? format(data.assetInfo.metadata.props.createdAt, 'MMM D, YYYY HH:mm')
        : '',
      createdBy: data.assetInfo.metadata.props.createdBy
    };
  };

  serializeEdit = workflow => {
    return {
      name: workflow.name
    };
  };

  serialize = workflow => {
    return {
      configValue: workflow.name,
      properties: {
        siteId: workflow.site.id
      }
    };
  };
}

export const WorkflowSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/workflow/index.js